import { DestructiveButton } from 'ui/button';
import { BUTTON_SIZES } from 'ui/button/constants';
import { ModalFooter, ModalBody, ModalHeader, Modal, MODAL_SIZES, MODAL_VARIANTS } from 'ui/modal';
import { getIsRecurringCampaign } from 'modules/campaigns/lib/utils';
import { ModalType, useCampaignContext, useModalContext } from '../../context';
import { BoldText } from '../../styles';
import {
  CANCEL_CAMPAIGN_MODAL_TEST_ID,
  CANCEL_CAMPAIGN_MODAL_CONFIRM_BUTTON_TEST_ID,
} from './CancelCampaignModal.constant';
import { useCancelCampaign } from './useCancelCampaign';

export const CancelCampaignModal = () => {
  const { closeModal } = useModalContext();
  const { campaign } = useCampaignContext();
  const { isLoading, cancelCampaign } = useCancelCampaign();

  const isRecurringCampaign = getIsRecurringCampaign(campaign);

  return (
    <Modal
      withPortal
      isModalOpen={true}
      onClose={() => closeModal(ModalType.CancelCampaignModal)}
      id={CANCEL_CAMPAIGN_MODAL_TEST_ID}
      data-test={CANCEL_CAMPAIGN_MODAL_TEST_ID}
      size={MODAL_SIZES.SMALL}
      variant={MODAL_VARIANTS.DELETE}
    >
      <ModalHeader autoFocus={false}>
        {isRecurringCampaign ? 'Stop recurring' : 'Cancel'} campaign?
      </ModalHeader>
      <ModalBody>
        {isRecurringCampaign ? (
          <>
            Are you sure you want to stop <BoldText>{campaign?.name}</BoldText> from recurring? Any
            scheduled campaigns will not be affected.
          </>
        ) : (
          <>
            Are you sure you want to cancel <BoldText>{campaign?.name}</BoldText>? This will stop
            messages from sending.
          </>
        )}
      </ModalBody>
      <ModalFooter>
        <DestructiveButton
          data-test={CANCEL_CAMPAIGN_MODAL_CONFIRM_BUTTON_TEST_ID}
          size={BUTTON_SIZES.LARGE}
          onClick={cancelCampaign}
          isLoading={isLoading}
        >
          {isRecurringCampaign ? 'Stop' : 'Cancel'} campaign
        </DestructiveButton>
      </ModalFooter>
    </Modal>
  );
};
